import type { RootState } from '../store';
import type { Category } from './categoryModels';

// Select all categories
export const selectAllCategories = (state: RootState) => 
  state.categories.categories;

// Select current category
export const selectCurrentCategory = (state: RootState) => 
  state.categories.currentCategory;

// Select products in current category
export const selectCategoryProducts = (state: RootState) => 
  state.categories.categoryProducts;

// Select loading state
export const selectCategoriesLoading = (state: RootState) => 
  state.categories.loading;

// Select error state
export const selectCategoriesError = (state: RootState) => 
  state.categories.error;

// Select status
export const selectCategoriesStatus = (state: RootState) => 
  state.categories.status;

// Select pagination info
export const selectCategoriesPagination = (state: RootState) => ({
  totalPages: state.categories.totalPages,
  currentPage: state.categories.currentPage,
  totalCategories: state.categories.totalCategories,
  totalProducts: state.categories.totalProducts,
});

// Select category by ID
export const selectCategoryById = (categoryId: string) => (state: RootState) => {
  return state.categories.categories.find((cat: Category) => cat._id === categoryId);
};

// Select categories with product count greater than 0
export const selectCategoriesWithProducts = (state: RootState) => {
  return state.categories.categories.filter((cat: Category) => cat.productCount > 0);
};

